/**
 * Round a point to the nearest integer.
 * @param point - Point to round.
 * @returns The rounded point.
 */
export function roundPoint(point) {
    return {
        row: Math.round(point.row),
        column: Math.round(point.column),
    };
}
//# sourceMappingURL=roundPoint.js.map